import type { Editor, NodeEntry } from 'slate';
import { Transforms } from 'slate';

import { mergeWithDefaults } from '../../../util';
import type { FooterElement } from '../../internal';
import { createDefaultFooterByType } from '../../internal';

export function normalizeFooter(editor: Editor, footerEntry: NodeEntry<FooterElement>): void {
  validateFooterProps(editor, footerEntry);
}

function validateFooterProps(editor: Editor, footerEntry: NodeEntry<FooterElement>): void {
  const [footer, footerPath] = footerEntry;
  const { children: footerChildren, ...footerProps } = footer;
  const { children: defaultFooterChildren, ...defaultFooterProps } = createDefaultFooterByType(
    footer.type
  );
  const missingKeys = Object.keys(defaultFooterProps).some(propKey => {
    const hasKey = propKey in footer;
    return !hasKey;
  });
  const newProps: Omit<FooterElement, 'children'> = mergeWithDefaults(
    footerProps,
    defaultFooterProps
  );
  if (!missingKeys) return;

  Transforms.setNodes(editor, newProps, { at: footerPath });
}
